import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import pdf from "../Assets/resume1.pdf"

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  const handleClickScroll = (section) => {
    const element = document.getElementById(section);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container style={{padding: 0}}>
        <Navbar.Brand href="/" className="d-flex">
          TK
        </Navbar.Brand>

        <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>


        <Navbar.Collapse id="responsive-navbar-nav" >
          <Nav className="ms-auto">
            <Nav.Item className={"align-self-center"}>

              <button
                  className={"nav-button"}
                  onClick={() => handleClickScroll("about")}
              >
              About
              </button>

            </Nav.Item>


            <Nav.Item>
              <button
                  className={"nav-button"}
                  onClick={() => handleClickScroll("projects")}
              >
                Projects
              </button>
            </Nav.Item>

            <Nav.Item>
              <button
                  className={"nav-button"}
                  onClick={() => window.open(pdf)}
              >
                Resume
              </button>


            </Nav.Item>

          </Nav>
        </Navbar.Collapse>



      </Container>
    </Navbar>
  );
}

export default NavBar;
